// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pQscrbeU_1pRCQxReSX0 {
    color: gray;
    margin: -7px 0 21px;
}

.OzQqx7gHHJyGwnxTjcBN {
    display: flex;
    min-height: 800px;
    background-color: white;
}

.H6RuDttxxvzpmwLBAivq {
    padding: 30px;
    display: flex;
    flex: 1;
}

.gT_qW0Y9sUegTbf8Vqls {
    min-width: 285px;
    padding: 24px;
    border-right: 1px solid #E0E0E0;
}

.kDGPx_ElrxWSApmFtkcA {
    color: rgb(50, 68, 90);
    font-size: 13px;
    padding: 5px 12px 5px 14px;
    border-radius: 2px;
    display: block;
    width: 100%;
}

.kDGPx_ElrxWSApmFtkcA.eUFr0hfWbI4WdEP65sbn {
    background-color: rgba(47, 181, 199, 0.2);
}

/* page specific css */

.hMNvN52VLo9Sh9GwltOG th {
    width: 8.33%;
}

.hMNvN52VLo9Sh9GwltOG th:first-child {
    width: initial;
}

.hMNvN52VLo9Sh9GwltOG td:first-child {
    line-height: 1.4;
}

.EipfkuzhlBEANdeQRv1u th {
    padding-right: 10px;
    width: 1000px;
}

.EipfkuzhlBEANdeQRv1u th:nth-child(1) {
    min-width: 300px;
}

.e3dtbQzuWUAggTW4maVz td:nth-child(4) {
    font-size: 12px;
}
.e3dtbQzuWUAggTW4maVz th:nth-child(5) {
    max-width: 100px;
}
.e3dtbQzuWUAggTW4maVz th:nth-child(6) {
    max-width: 60px;
}

.b2X_VSAy6oGg22oFGR7g th:nth-child(1) {
    min-width: 300px;
}

.WHANv1toZ_jSwNFlj9lS th {
    min-width: 8%;
    width: 8%;
}

.WHANv1toZ_jSwNFlj9lS th:nth-child(1) {
    min-width: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/reports/reports.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,sBAAsB;;AAEtB;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".explainer {\n    color: gray;\n    margin: -7px 0 21px;\n}\n\n.reportsContainer {\n    display: flex;\n    min-height: 800px;\n    background-color: white;\n}\n\n.pageWrapper {\n    padding: 30px;\n    display: flex;\n    flex: 1;\n}\n\n.sidebarWrapper {\n    min-width: 285px;\n    padding: 24px;\n    border-right: 1px solid #E0E0E0;\n}\n\n.sidebarLink {\n    color: rgb(50, 68, 90);\n    font-size: 13px;\n    padding: 5px 12px 5px 14px;\n    border-radius: 2px;\n    display: block;\n    width: 100%;\n}\n\n.sidebarLink.sidebarLinkActive {\n    background-color: rgba(47, 181, 199, 0.2);\n}\n\n/* page specific css */\n\n.listHealthTable th {\n    width: 8.33%;\n}\n\n.listHealthTable th:first-child {\n    width: initial;\n}\n\n.listHealthTable td:first-child {\n    line-height: 1.4;\n}\n\n.applicationSources th {\n    padding-right: 10px;\n    width: 1000px;\n}\n\n.applicationSources th:nth-child(1) {\n    min-width: 300px;\n}\n\n.userStats td:nth-child(4) {\n    font-size: 12px;\n}\n.userStats th:nth-child(5) {\n    max-width: 100px;\n}\n.userStats th:nth-child(6) {\n    max-width: 60px;\n}\n\n.applicationDob th:nth-child(1) {\n    min-width: 300px;\n}\n\n.applicationRace th {\n    min-width: 8%;\n    width: 8%;\n}\n\n.applicationRace th:nth-child(1) {\n    min-width: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"explainer": `pQscrbeU_1pRCQxReSX0`,
	"reportsContainer": `OzQqx7gHHJyGwnxTjcBN`,
	"pageWrapper": `H6RuDttxxvzpmwLBAivq`,
	"sidebarWrapper": `gT_qW0Y9sUegTbf8Vqls`,
	"sidebarLink": `kDGPx_ElrxWSApmFtkcA`,
	"sidebarLinkActive": `eUFr0hfWbI4WdEP65sbn`,
	"listHealthTable": `hMNvN52VLo9Sh9GwltOG`,
	"applicationSources": `EipfkuzhlBEANdeQRv1u`,
	"userStats": `e3dtbQzuWUAggTW4maVz`,
	"applicationDob": `b2X_VSAy6oGg22oFGR7g`,
	"applicationRace": `WHANv1toZ_jSwNFlj9lS`
};
export default ___CSS_LOADER_EXPORT___;
